import type { ProductVariant } from "./types";

/** El parámetro del enlace al checkout para una variante: "Talla" → "talla". */
export function variantParam(variant: ProductVariant): string {
  return variant.label.toLowerCase();
}

/** El enlace al checkout con las variantes elegidas: /checkout?talla=42&color=negro. */
export function checkoutHref(variants: readonly ProductVariant[], selection: Readonly<Record<string, string>>): string {
  const params = new URLSearchParams();
  for (const variant of variants) {
    const option = selection[variant.label];
    if (option) params.set(variantParam(variant), option.toLowerCase());
  }
  const query = params.toString();
  return query ? "/checkout?" + query : "/checkout";
}
